import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sym-component-load-emitter',
  templateUrl: './component-load-emitter.component.html',
})
export class ComponentLoadEmitterComponent implements OnInit, AfterViewInit {
  constructor() {}

  @Output() componentLoaded = new EventEmitter<boolean>();

  ngOnInit() {}

  ngAfterViewInit() {
    this.componentLoaded.emit(true);
  }
}
